const initialState = {
    loading: false,
    loadError: false,
    flaggedChatList: [],
    hasMore: false,
    faqList: [],
    playground: {
        loading: false,
        loadError: false,
        instanceList: []
    }
}

export default initialState
